import { detect } from 'detect-browser';
const browser = detect();
export const browserName = browser ? browser.name : '';
